'use strict';

angular
    .module('prism-ui.components.data')
    .directive('ignoreDirty', [function() {
        return {
            restrict: 'A', // restrict to attributes
            require: 'ngModel', // require ngModel controller
            link: function(scope, element, attrs, ngModelCtrl) {
                // Override $setDirty method to do nothing
                ngModelCtrl.$setDirty = function() {};
            }
        };
    }]);
